export default {
  // Navigation
  nav_home: "होम",
  nav_products: "उत्पाद",
  nav_about: "हमारे बारे में",
  nav_support: "सहायता",
  nav_contact: "संपर्क करें",

  // Hero Section
  hero_title: "ताइशान संगीत वाद्ययंत्र",
  hero_subtitle: "प्रीमियम चीनी संगीत वाद्ययंत्र",
  hero_description: "1987 से उच्च गुणवत्ता वाले पीतल के वाद्ययंत्र निर्माण के लिए समर्पित",
  hero_cta: "उत्पाद देखें",

  // Products Section
  products_title: "हमारे उत्पाद",
  products_subtitle: "पेशेवर पीतल के वाद्ययंत्र, उत्कृष्टता के साथ तैयार",
  product_trumpet: "ट्रम्पेट श्रृंखला",
  product_trumpet_desc: "उज्ज्वल, पूर्ण स्वर के साथ पेशेवर पीतल का वाद्ययंत्र, सभी प्रदर्शन अवसरों के लिए उपयुक्त",
  product_trombone: "ट्रॉम्बोन श्रृंखला",
  product_trombone_desc: "सुचारू स्लाइड क्रिया, विस्तृत श्रेणी, पेशेवर ऑर्केस्ट्रा द्वारा पसंदीदा",
  product_saxophone: "सैक्सोफोन श्रृंखला",
  product_saxophone_desc: "समृद्ध, मधुर स्वर, जैज़ और शास्त्रीय संगीत के लिए एकदम सही",
  product_horn: "फ्रेंच हॉर्न श्रृंखला",
  product_horn_desc: "कोमल, गर्म स्वर, सिम्फनी ऑर्केस्ट्रा के लिए आवश्यक",
  product_clarinet: "क्लैरिनेट श्रृंखला",
  product_clarinet_desc: "स्पष्ट, मनमोहक स्वर के साथ क्लासिक वुडविंड वाद्ययंत्र",
  product_flute: "बांसुरी श्रृंखला",
  product_flute_desc: "कुरकुरा, मधुर स्वर, एकल और समूह प्रदर्शन के लिए आदर्श",
  view_details: "विवरण देखें",

  // Product Catalog
  catalog_title: "उत्पाद कैटलॉग डाउनलोड",
  catalog_description: "विस्तृत उत्पाद विनिर्देशों के लिए पूर्ण ताइशान इंस्ट्रूमेंट्स कैटलॉग डाउनलोड करें",
  catalog_download: "कैटलॉग डाउनलोड करें",

  // About Section
  about_title: "हमारे बारे में",
  about_subtitle: "30 से अधिक वर्षों की शिल्प कौशल विरासत",
  about_heading: "ताइशान संगीत वाद्ययंत्र के बारे में",
  about_p1: "शेडोंग ताइशान ब्रास इंस्ट्रूमेंट मैन्युफैक्चरिंग कंपनी लिमिटेड की स्थापना 1987 में हुई थी और यह चीन में एक अग्रणी पेशेवर पीतल वाद्ययंत्र निर्माता है। शेडोंग प्रांत में स्थित, कंपनी के पास एक आधुनिक उत्पादन आधार और एक पेशेवर R&D टीम है।",
  about_p2: "2004 में, कंपनी के उत्पादों का संस्कृति मंत्रालय के संगीत वाद्ययंत्र गुणवत्ता पर्यवेक्षण और निरीक्षण केंद्र द्वारा परीक्षण किया गया और सभी राष्ट्रीय मानकों को पूरा किया। 2006 में, कंपनी सफलतापूर्वक एक प्रत्यक्ष समीक्षा इकाई बन गई और उसे 'चीन के संगीत वाद्ययंत्र उद्योग में मजबूत उद्यम' का खिताब दिया गया।",
  about_p3: "कंपनी ने ISO9001 गुणवत्ता प्रणाली प्रमाणन और ISO14001 पर्यावरण प्रणाली प्रमाणन पारित किया है। उत्पाद दुनिया भर के कई देशों और क्षेत्रों में निर्यात किए जाते हैं और संगीत प्रेमियों और पेशेवर कलाकारों द्वारा भरोसा किया जाता है।",
  about_year: "स्थापित",
  about_series: "उत्पाद श्रृंखला",

  // Timeline
  timeline_title: "हमारी यात्रा",
  timeline_1987: "कंपनी की स्थापना, पीतल वाद्ययंत्र निर्माण पर ध्यान केंद्रित",
  timeline_2001: "चीन अंतर्राष्ट्रीय संगीत वाद्ययंत्र प्रदर्शनी का सदस्य बना",
  timeline_2004: "उत्पादों ने संस्कृति मंत्रालय के संगीत वाद्ययंत्र गुणवत्ता पर्यवेक्षण केंद्र द्वारा निरीक्षण पारित किया, राष्ट्रीय मानकों को पूरा किया",
  timeline_2006: "'चीन के संगीत वाद्ययंत्र उद्योग में मजबूत उद्यम' खिताब से सम्मानित",
  timeline_2013: "ताइशान पीतल के वाद्ययंत्र अंतरराष्ट्रीय स्तर पर प्रसिद्ध ब्रांडों के साथ प्रतिस्पर्धा करने वाला चीनी ब्रांड बन गया",
  timeline_2019: "शेडोंग प्रांतीय विज्ञान और प्रौद्योगिकी विभाग द्वारा 'विशेष, परिष्कृत, विशिष्ट और नवीन' SME खिताब से सम्मानित",

  // Support Section
  support_title: "सहायता और सेवा",
  support_subtitle: "पेशेवर बिक्री के बाद सेवा प्रणाली",
  support_quality: "गुणवत्ता आश्वासन",
  support_quality_desc: "ISO9001 प्रमाणित, प्रत्येक उत्पाद कठोर परीक्षण से गुजरता है",
  support_service: "बिक्री के बाद सेवा",
  support_service_desc: "रखरखाव और परामर्श प्रदान करने वाली पेशेवर बिक्री के बाद टीम",
  support_maintenance: "मरम्मत और रखरखाव",
  support_maintenance_desc: "पेशेवर वाद्ययंत्र मरम्मत और रखरखाव सेवाएं",
  support_guide: "उपयोगकर्ता गाइड",
  support_guide_desc: "विस्तृत उपयोग निर्देश और रखरखाव दिशानिर्देश",

  // FAQ
  faq_title: "अक्सर पूछे जाने वाले प्रश्न",
  faq_q1: "मैं सही पीतल वाद्ययंत्र कैसे चुनूं?",
  faq_a1: "हम आपके बजने के स्तर, संगीत शैली और बजट के आधार पर चुनने की सलाह देते हैं। शुरुआती लोग प्रवेश स्तर के उत्पादों का विकल्प चुन सकते हैं, जबकि पेशेवर कलाकार उच्च-अंत श्रृंखला चुन सकते हैं। हमारी ग्राहक सेवा टीम पेशेवर सलाह प्रदान कर सकती है।",
  faq_q2: "वारंटी अवधि क्या है?",
  faq_a2: "हमारे उत्पाद एक साल की वारंटी के साथ आते हैं। सामान्य उपयोग के तहत गुणवत्ता के मुद्दों की मरम्मत या मुफ्त में बदल दिया जाएगा।",
  faq_q3: "मैं पीतल के वाद्ययंत्रों का रखरखाव कैसे करूं?",
  faq_a3: "हम प्रत्येक उपयोग के बाद वाद्ययंत्र के आंतरिक भाग को साफ करने, नियमित रूप से वाल्व और स्लाइड को तेल लगाने, टकराव और चरम तापमान से बचने की सलाह देते हैं। विस्तृत रखरखाव दिशानिर्देशों के लिए कृपया उत्पाद मैनुअल देखें।",
  faq_q4: "क्या आप अंतर्राष्ट्रीय शिपिंग प्रदान करते हैं?",
  faq_a4: "हां, हमारे उत्पाद दुनिया भर के कई देशों और क्षेत्रों में बेचे जाते हैं। विशिष्ट शिपिंग विधियों और लागतों के लिए कृपया हमारी बिक्री टीम से संपर्क करें।",

  // Contact Section
  contact_title: "संपर्क करें",
  contact_subtitle: "हम आपसे सुनने के लिए उत्सुक हैं",
  contact_info: "संपर्क जानकारी",
  contact_address: "पता",
  contact_address_value: "शेडोंग प्रांत, चीन",
  contact_phone: "फोन",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "WhatsApp पर चैट करें",
  contact_email: "ईमेल",
  contact_email_value: "कृपया फॉर्म के माध्यम से एक संदेश छोड़ें, हम जल्द से जल्द जवाब देंगे",
  contact_hours: "व्यावसायिक घंटे",
  contact_hours_value: "सोमवार से शुक्रवार 9:00-18:00",
  contact_form_title: "एक संदेश छोड़ें",
  contact_form_name: "नाम",
  contact_form_email: "ईमेल",
  contact_form_phone: "फोन",
  contact_form_message: "संदेश",
  contact_form_submit: "जमा करें",
  contact_form_name_placeholder: "कृपया अपना नाम दर्ज करें",
  contact_form_email_placeholder: "कृपया अपना ईमेल दर्ज करें",
  contact_form_phone_placeholder: "कृपया अपना फोन नंबर दर्ज करें",
  contact_form_message_placeholder: "कृपया अपना संदेश दर्ज करें (अधिकतम 500 वर्ण)",
  contact_form_required: "आवश्यक",
  contact_form_success: "सफलतापूर्वक जमा किया गया! हम जल्द ही आपसे संपर्क करेंगे।",
  contact_form_error: "सबमिशन विफल, कृपया बाद में पुनः प्रयास करें।",
  contact_form_validate_required: "कृपया सभी आवश्यक फ़ील्ड भरें",
  contact_form_validate_email: "कृपया एक मान्य ईमेल पता दर्ज करें",
  contact_form_validate_message: "संदेश 500 वर्णों से अधिक नहीं हो सकता",

  // Footer
  footer_description: "उच्च गुणवत्ता वाले पीतल वाद्ययंत्र निर्माण के लिए समर्पित, संगीत प्रेमियों और पेशेवर कलाकारों के लिए उत्कृष्ट उत्पाद प्रदान करना।",
  footer_quick_links: "त्वरित लिंक",
  footer_contact_us: "हमसे संपर्क करें",
  footer_address: "पता: शेडोंग प्रांत, चीन",
  footer_hours: "व्यावसायिक घंटे: सोमवार से शुक्रवार 9:00-18:00",
  footer_copyright: "सर्वाधिकार सुरक्षित।",
  footer_powered: "Readdy द्वारा संचालित"
};
